import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';


export default function IconList({className, height, title}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M7.02798 1.8233C7.32088 1.53041 7.32088 1.05553 7.02798 0.762639C6.73509 0.469745 6.26022 0.469745 5.96732
      0.762639L3.00011 3.72986L1.57333 2.30308C1.28044 2.01019 0.805562 2.01019 0.512669 2.30308C0.219776 2.59597
      0.219776 3.07085 0.512669 3.36374L2.46978 5.32085C2.76267 5.61374 3.23754 5.61374 3.53044 5.32085L7.02798
      1.8233ZM7.02795 8.82326C7.32085 8.53036 7.32085 8.05549 7.02795 7.7626C6.73506 7.4697 6.26019 7.4697 5.96729
      7.7626L3.00008 10.7298L1.5733 9.30304C1.28041 9.01014 0.805533 9.01014 0.51264 9.30304C0.219747 9.59593 0.219747
      10.0708 0.51264 10.3637L2.46975 12.3208C2.76264 12.6137 3.23751 12.6137 3.53041 12.3208L7.02795 8.82326ZM7.02795
      14.7626C7.32085 15.0555 7.32085 15.5304 7.02795 15.8233L3.53041 19.3208C3.23751 19.6137 2.76264 19.6137 2.46975
      19.3208L0.512639 17.3637C0.219745 17.0708 0.219745 16.596 0.512639 16.3031C0.805532 16.0102 1.28041 16.0102 1.5733
      16.3031L3.00008 17.7299L5.96729 14.7626C6.26019 14.4697 6.73506 14.4697 7.02795 14.7626ZM9.75009 2.75C9.33588 2.75
      9.00009 3.08579 9.00009 3.5C9.00009 3.91421 9.33588 4.25 9.75009 4.25H19.2501C19.6643 4.25 20.0001 3.91421 20.0001
      3.5C20.0001 3.08579 19.6643 2.75 19.2501 2.75H9.75009ZM9.00009 10.5C9.00009 10.0858 9.33588 9.75 9.75009
      9.75H19.2501C19.6643 9.75 20.0001 10.0858 20.0001 10.5C20.0001 10.9142 19.6643 11.25 19.2501 11.25H9.75009C9.33588
      11.25 9.00009 10.9142 9.00009 10.5ZM9.75009 16.75C9.33588 16.75 9.00009 17.0858 9.00009 17.5C9.00009 17.9142
      9.33588 18.25 9.75009 18.25H19.2501C19.6643 18.25 20.0001 17.9142 20.0001 17.5C20.0001 17.0858 19.6643 16.75
      19.2501 16.75H9.75009Z
    </Icon>
  );
}
